import { createSlice } from "@reduxjs/toolkit";
import { roleIds } from "../../constant";
import { CUSTOMER_DEFAULT_ADDRESS_KEY, CUSTOMER_SELECTED_CLIENT_KEY } from "../../pages/CheckOut";

const initialState = {
  role_id: null,
  role: null,
  token: null,
  user_id: null,
  is_email_verified: null,
  is_blocked: null,
  company_name: null,
  full_name: null,
  email: null,
  profile_url: null,
  offer_shown: false,
  customer_id: null,
  contact_person: null,
  is_agree_terms: null,
  user: null,
  is_sales_manager: false,
  is_sales_person: false,
  is_customer: false,
  is_admin: false,
  party_code: null,
  is_agent: false,
  agent_data: null,
  permissions: [],
  permission_ids: [],
};

export const loginSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthLogin: (state, actions) => {
      const {
        role_id,
        role,
        token,
        user_id,
        company_name,
        full_name,
        email,
        is_blocked,
        profile_url,
        is_email_verified,
        customer_id,
        contact_person,
        is_agree_terms,
        user,
        is_agent,
        party_code,
        agent_data,
        permissions,
      } = actions.payload;
      if (role_id !== undefined) state.role_id = role_id;
      else {
        state.role_id = roleIds.Customer;
      }

      if (token !== undefined) state.token = token;
      if (user_id !== undefined) state.user_id = user_id;
      if (company_name !== undefined) state.company_name = company_name;
      if (full_name !== undefined) state.full_name = full_name;
      if (email !== undefined) state.email = email;
      if (is_blocked !== undefined) state.is_blocked = is_blocked;
      if (profile_url !== undefined) state.profile_url = profile_url;
      if (is_email_verified !== undefined) state.is_email_verified = is_email_verified;
      if (role !== undefined) state.role = role;
      if (customer_id !== undefined) state.customer_id = customer_id;
      if (contact_person !== undefined) state.contact_person = contact_person;
      if (is_agree_terms !== undefined) state.is_agree_terms = is_agree_terms;
      if (user !== undefined) state.user = user;
      if (state.role_id) {
        state.is_sales_manager = state.role_id === roleIds.SalesManager;
        state.is_sales_person = state.role_id === roleIds.SalesPerson;
        state.is_customer = state.role_id === roleIds.Customer;
        state.is_admin = state.role_id === roleIds.Admin;
      }
      state.party_code = party_code;
      state.is_agent = is_agent;
      state.agent_data = agent_data;
      state.permissions = permissions;
      state.permission_ids = permissions?.map((item) => item.permission_id) || [];
    },
    setOfferShown: (state, action) => {
      state.offer_shown = action.payload;
    },
    resetState: () => {
      Object.keys(sessionStorage).forEach((key) => {
        if (
          key.startsWith("filters:") ||
          key.startsWith("pagination:") ||
          key.startsWith("customerSelection:") ||
          key.startsWith(CUSTOMER_SELECTED_CLIENT_KEY) ||
          key.startsWith(CUSTOMER_DEFAULT_ADDRESS_KEY)
        ) {
          sessionStorage.removeItem(key);
        }
      });
      return initialState;
    },
  },
});

export const { setAuthLogin, setOfferShown, resetState } = loginSlice.actions;

export default loginSlice.reducer;
